/** Inline-Styles für zuverlässige Darstellung in E-Mail-Clients und Inbox-Vorschau. */
export const EMAIL_BODY_P_MARGIN = 'margin:0 0 0.75em 0';
export const EMAIL_BODY_P_LAST_MARGIN = 'margin:0 0 0.25em 0';
export const EMAIL_SIG_P_MARGIN = 'margin:0;line-height:1.35';
export const EMAIL_PARAGRAPH_GAP_HTML =
  '<div style="height:0.75em;line-height:0.75em;font-size:0.75em">&nbsp;</div>';
export const EMAIL_SIGNATURE_GAP_HTML =
  '<div style="height:8px;line-height:8px;font-size:8px">&nbsp;</div>';

const SIGNATURE_GAP_SENT_RE =
  /<div\s+style="height:8px;line-height:8px;font-size:8px"[^>]*>\s*(?:&nbsp;)?\s*<\/div>/i;

function mergeTagStyle(tagOpen: string, tagName: string, style: string): string {
  const styleMatch = tagOpen.match(/\bstyle\s*=\s*"([^"]*)"/i);
  if (styleMatch) {
    const existing = styleMatch[1];
    if (/margin/i.test(existing) && /line-height/i.test(existing)) return tagOpen;
    if (/margin/i.test(existing)) return tagOpen;
    return tagOpen.replace(styleMatch[0], `style="${existing};${style}"`);
  }
  return tagOpen.replace(new RegExp(`^<${tagName}\\b`, 'i'), `<${tagName} style="${style}"`);
}

function applyParagraphStyles(html: string, pStyle: string, lastPStyle?: string): string {
  const opens: string[] = [];
  html.replace(/<p\b[^>]*>/gi, (m) => {
    opens.push(m);
    return m;
  });
  if (opens.length === 0) return html;
  let idx = 0;
  return html.replace(/<p\b[^>]*>/gi, (full) => {
    const style = idx === opens.length - 1 && lastPStyle ? lastPStyle : pStyle;
    idx += 1;
    return mergeTagStyle(full, 'p', style);
  });
}

function normalizeParagraphBreaks(html: string): string {
  return html.replace(/(?:<br\s*\/?>\s*){2,}/gi, EMAIL_PARAGRAPH_GAP_HTML);
}

export function splitBodyAndSignature(html: string): { body: string; signature: string | null } {
  const raw = String(html || '').trim();
  if (!raw) return { body: '', signature: null };

  const sentGap = SIGNATURE_GAP_SENT_RE.exec(raw);
  if (!sentGap || sentGap.index < 0) return { body: raw, signature: null };

  const body = raw.slice(0, sentGap.index).trim();
  let signature = raw.slice(sentGap.index + sentGap[0].length).trim();
  signature = signature.replace(/^<div>([\s\S]*)<\/div>$/i, '$1').trim();
  return { body, signature: signature || null };
}

export function formatEmailBodySection(html: string): string {
  const section = normalizeParagraphBreaks(String(html || '').trim());
  if (!section) return '';
  return applyParagraphStyles(section, EMAIL_BODY_P_MARGIN, EMAIL_BODY_P_LAST_MARGIN);
}

export function formatEmailSignatureSection(html: string): string {
  const section = String(html || '').trim();
  if (!section) return '';
  return applyParagraphStyles(section, EMAIL_SIG_P_MARGIN);
}

/** Formatiert Mail-Body + optionale Signatur für Versand und Vorschau. */
export function formatEmailHtmlWithSignature(bodyHtml: string, signatureHtml: string | null): string {
  const body = formatEmailBodySection(bodyHtml);
  const signature = String(signatureHtml || '').trim();
  if (!signature) return body;
  const sig = formatEmailSignatureSection(signature);
  return `${body}${EMAIL_SIGNATURE_GAP_HTML}<div>${sig}</div>`;
}

/** Formatiert bereits kombiniertes Mail-HTML (z. B. aus Nylas-Sync). */
export function formatEmailHtmlForDisplay(html: string): string {
  const { body, signature } = splitBodyAndSignature(html);
  if (!signature) return formatEmailBodySection(body);
  return formatEmailHtmlWithSignature(body, signature);
}
